export const CHANGE_LOADING = "App/CHANGE_LOADING"